import React from 'react';

const ArrowUp: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 3.33594V12.6693" stroke="#12B76A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d="M12 7.33594L8 3.33594" stroke="#12B76A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d="M4 7.33594L8 3.33594" stroke="#12B76A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);

export default ArrowUp;
